import request from '@/utils/request'

/**
 * 发送短信验证码
 * @param {string} phone - 手机号
 */
export function sendSms(phone) {
    return request.post('/app/auth/sendSms', { phone }, { token: false, showError: false })
}

/**
 * 短信验证码登录
 * @param {object} data - 登录数据 { phone, code }
 */
export function smsLogin(data) {
    return request.post('/app/auth/smsLogin', data, { token: false, showError: false })
}

/**
 * 密码登录
 * @param {object} data - 登录数据 { username, password }
 */
export function passwordLogin(data) {
    return request.post('/app/auth/phoneLogin', data, { token: false, showError: false })
}

/**
 * 微信登录
 * @param {object} data - 登录数据 { code }
 */
export function weChatLogin(data) {
    return request.post('/app/auth/weChatLogin', data, { token: false, showError: false })
}

/**
 * 绑定支付宝账号
 * @param {object} data - { payOpenId, payAccountName }
 */
export function bindAlipay(data) {
    return request.put('/app/user/bindAlipay', data, { needRedirect: false, showError: false })
}

/**
 * 获取用户信息
 */
export function getInfo() {
    return request.get('/app/auth/getInfo', {}, { needRedirect: false, showError: false, token: true })
}

/**
 * 退出登录
 */
export function logout() {
    return request.post('/app/auth/logout')
}

/**
 * 验证 Token 是否有效
 */
export function verifyToken() {
    return request.get('/app/user/verifyToken', {}, { showError: false, needRedirect: false })
}

/**
 * 获取微信公众号登录二维码
 */
export function getWechatCode() {
    return request.post('/app/auth/weChat/qr', {}, { token: false })
}

/**
 * 检查微信公众号登录状态
 * @param {string} sessionId - 二维码会话 ID
 */
export function checkWechatStatus(sessionId) {
    return request.get('/app/auth/weChat/qr/status', { sessionId }, { token: false, showError: false })
}

/**
 * 微信登录绑定手机号
 * @param {object} data - 登录数据 { userId, phone, code }
 */
export function weChatBindPhone(data) {
    return request.post('/app/auth/weChat/bindPhone', data, { token: false, showError: false })
}

/**
 * 刷新 Token
 */
export function refreshToken() {
    return request.get('/app/auth/refreshToken', {}, { showError: false, needRedirect: false })
}
